
import vpsPageData from "../../data/vps";
import Calculator from "../../components/vps/calculator.vue";
import Customers from "../../components/vps/customers.vue";
import Os from "../../components/vps/os.vue";
import Plans from "../../components/vps/plans.vue";
import Benefits from "../../components/vps/benefits.vue";

import Modal from "../../components/rebranding/modal/Modal.vue";
import Uses from "../../components/vps/uses.vue";
import DiffrenceVPS from "../../components/vps/DiffrenceVPS.vue";

import {
  featuresHourlyServer,
  benefitHourlyServer,
  hourlyServerUsage,
} from "../../data/hourlyVps";

import {
  headerEuropeServerData,
  questions,
  abalonPopularServices,
  tabItems,
  serviceFeatures,
  europeVpsUsage,
  europeVpsFeatures,
} from "../../data/europeVps";
export default {
  components: {
    Calculator,
    Os,
    Customers,
    Plans,
    Benefits,
    Modal,
    Uses,
    DiffrenceVPS,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title:
        "خرید سرور ابری ایرانی و خارجی | سرور ابری ساعتی و ماهانه | آبالون",
      meta: [
        {
          name: "description",
          content:
            "با خرید سرور ابری آبالون تمام امکانات یک سرور قدرتمند را با منابع دلخواه، به صورت اختصاصی و با پشتیبانی رایگان ۲۴ ساعته تحویل بگیرید.",
        },
        {
          name: "keywords",
          content: "خرید سرور ابری، سرور ابری, vps, خرید vps",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/vps",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content:
            "خرید سرور ابری ایرانی و خارجی | سرور ابری ساعتی و ماهانه | آبالون",
        },
        {
          property: "og:description",
          content:
            "با خرید سرور ابری آبالون تمام امکانات یک سرور قدرتمند را با منابع دلخواه، به صورت اختصاصی و با پشتیبانی رایگان ۲۴ ساعته تحویل بگیرید.",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/vps",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          title:
            "خرید سرور ابری ایرانی و خارجی | سرور ابری ساعتی و ماهانه | آبالون",
        },
        {
          name: "twitter:description",
          content:
            "با خرید سرور ابری آبالون تمام امکانات یک سرور قدرتمند را با منابع دلخواه، به صورت اختصاصی و با پشتیبانی رایگان ۲۴ ساعته تحویل بگیرید.",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/vps",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "سرور ابری چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سرور ابری یک سرور مجازی پیشرفته است که زیرساخت فناوری اطلاعات کامل و مبتنی بر وب شامل قدرت پردازش، فضای ذخیره سازی، فناوری شبکه و… را در اختیار شما قرار می‌دهد. با سرور ابری شما دیگر نیازی به سخت افزار سرور فیزیکی خود ندارید! شما به راحتی می‌توانید داده‌ها را بر بستر وب یا مستقل از مکان، پردازش، تبادل، ایمن‌سازی و مدیریت کنید.",
                },
              },
              {
                "@type": "Question",
                name: "تفاوت بین سرور ابری و سرور مجازی چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "برخلاف سرورهای مجازی، که در آن شما فقط می‌توانید از منابع سرور تا حد مشخصی استفاده کنید، سرورهای ابری با مقیاس‌پذیری مشخص می‌شوند. اگر نیازهای شما تغییر کند، می‌توانید منابع سرور اختصاص داده شده را در هر زمان و به صورت Real Time افزایش یا کاهش دهید و صورت‌حساب بر اساس منابعی است که استفاده می‌کنید، به این معنی که شما فقط برای آنچه واقعاً استفاده می‌کنید پرداخت می‌کنید.",
                },
              },
              {
                "@type": "Question",
                name: "آیا داده‌های من امن است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "امنیت داده‌ها در تمامی محصولات و خدمات «آبالون» اولویت اصلی‌ست. این امر در مورد تمامی بسته‌های میزبانی سرور ابری ما نیز صدق می‌کند. با سرور ابری «آبالون»، نه تنها از انتقال داده‌های رمزگذاری شده، بلکه از ذخیره‌سازی رمزگذاری شده و پشتیبان‌گیری منظم از داده‌ها نیز بهره‌مند خواهید شد. زیرساخت امنیتی دیجیتال و فیزیکی «آبالون» از داده‌های شما به طور جامع محافظت می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "مزایای سرور ابری چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سرورهای ابری مزایای متعددی از جمله: افزایش انعطاف‌پذیری، مقرون به صرفه بودن، مقیاس‌پذیری، امنیت، قابلیت اطمینان و قدرت پردازش را ارائه می‌دهند. یک سرور ابری شرکت‌ها را قادر می‌سازد تا از هزینه‌های بالا برای تهیه، استقرار، مدیریت و ارتقاء سرورهای فیزیکی در محل، خودداری کنند. یک سرور ابری، توان پردازشی را بر حسب تقاضا فراهم می‌کند و با تغییر نیازمندی‌های منابع، مقیاس‌پذیری آسان را ممکن می‌سازد. با یک سرور ابری، شرکت‌ها فقط برای منابعی که مصرف می‌کنند پرداخت می‌کنند و به کاهش قابل توجه هزینه‌ها کمک می‌کنند.",
                },
              },
              {
                "@type": "Question",
                name: "انواع سرور ابری",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سه نوع اصلی از سرورهای ابری وجود دارد: سرورهای عمومی یا Publicکه در این حالت منابع پردازشی بین کاربران به اشتراک گذاشته می‌شود، سرورهای اختصاصی یا Private که منابع سرور به اشتراک گذاشته نخواهد شد و فقط برای استفاده یک کاربر ایزوله می‌شود و سرورهای ترکیبی یا Hybrid که با توجه به نیاز کاربر می‌تواند ترکیبی از دو حالت عمومی و اختصاصی باشد.",
                },
              },
              {
                "@type": "Question",
                name: "چه زمانی باید سرور ابری خریداری کنیم؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "راه‌اندازی یک سرور ابری برای هر کسی که خواهان زیرساخت قدرتمند فناوری اطلاعات با قیمت مناسب است، ارزشمند است. سرور ابری همچنین یک بستر ایده‌آل برای طیف گسترده‌ای از پروژه‌های وب ارائه می‌دهد. موارد دیگر تشخیص زمان مناسب برای خرید سرور ابری عبارتند از: نیاز به بالا آوردن یک وب‌سایت اختصاصی، نیاز به زیرساخت با کارایی بالا برای توسعه‌دهندگان وب، استفاده به عنوان یک سرور بازی با عملکرد بالا، زمانی که قصد راه‌اندازی یک استارتاپ را دارید و هنوز از نیازهای واقعی زیرساخت فناوری اطلاعات خود مطمئن نیستید",
                },
              },
              {
                "@type": "Question",
                name: "چطور یک سرور ابری مناسب را انتخاب کنم؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "هنگام انتخاب یک سرور ابری، با اولویت بندی نیازهای خود بر اساس بودجه، فناوری، اولویت‌ها و قابلیت‌هایی که نیاز دارید شروع کنید، بعد از شناخت درست نیازهای‌تان قدم بعدی انتخاب ارائه‌دهنده یا اپراتور خدمات ابری‌ست. تصمیم مهم دیگر این است که چه نوع اپراتور رایانش ابری برای کسب‌وکار شما مناسب است: ارائه‌دهندگان ابر عمومی، خصوصی یا ترکیبی.",
                },
              },
              {
                "@type": "Question",
                name: "هزینه سرور ابری چقدر است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "قیمت‌ها بسته به زیرساخت و منابع خاصی که استفاده می‌کنید و همچنین زمان واقعی کارکرد سیستم شما، بسیار متفاوت است. میزان پردازنده، حافظه، فضای دیسک و… از جمله فاکتورهای تأثیرگذار بر قیمت هستند. علاوه بر این سطح خدمات کیفی و پشتیبانی که از آن استفاده می‌کنید نیز روی قیمت نهایی اثر می‌گذارند، کل لیست پکیج‌ها، امکانات و قیمت هر کدام را می‌توانید در بخش طرح‌ها و قیمت‌هاببینید.",
                },
              },
              {
                "@type": "Question",
                name: "چه خدمات پشتیبانی‌ای همراه سرور ابری «آبالون» ارائه می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "قابلیت انتخاب سطح کیفی سرویس به همراه داشبورد ابری و یکپارچه «آبالون» برای هرگونه تغییرات در منابع و زیرساخت‌ها در سریع‌ترین زمان ممکن جزء خدمات پشتیبانی «آبالون» به حساب می‌آید، علاوه بر این، پشتیبان فنی رایگان و پشتیبانی سرویس‌ها به صورت 365/24/7 در تمام لحظات سال جزء مواردی‌ست که در «آبالون» در اختیار شما خواهد بود.",
                },
              },
              {
                "@type": "Question",
                name: "آیا می‌توانم از اطلاعات خود در یک سرور ابری بک‌آپ بگیرم؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، می توانید از اطلاعات خود در سرور ابری «آبالون» نسخه پشتیبان تهیه کنید. یک کلاینت پشتیبان و همچنین یک ذخیره‌سازی پشتیبان جداگانه و اضافی همیشه در دسترس است، در سرور ابری «آبالون» تمام اطلاعات شما رمزگذاری شده و در یک دیتاسنتر جداگانه از لحاظ فیزیکی پشتیبان‌گیری می‌شود و حتی می‌توانید چندین بار از اطلاعات خود نسخه پشتیبان تهیه کنید.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "سرور ابری آبالون",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      benefits: benefitHourlyServer,
      dataBlog: vpsPageData.dataBlog,
      questions: questions,
      uses: vpsPageData.uses,
      locations: vpsPageData.locations,
      activeSection: "",
      PopularServices: abalonPopularServices,
      tabItems: tabItems,
      serviceFeatures: serviceFeatures,
      tab: 0,
      showmore: false,
      hourlyServerUsage: hourlyServerUsage,
      headerData: headerEuropeServerData,
      featuresHourlyServer: featuresHourlyServer,
      europeVpsUsage: europeVpsUsage,
      europeVpsFeatures: europeVpsFeatures,
    };
  },
  mounted() {},
  methods: {
    playVid() {
      var vid = document.getElementById("myVideo");

      vid.play();
    },

    pauseVid() {
      var vid = document.getElementById("myVideo");

      vid.pause();
    },
    spliceNumber(number) {
      if (number != null) {
        number = Math.round(number);
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
    },
    handleScroll(e) {
      var sectionsElement = document.getElementsByClassName("sections")[0];

      if (sectionsElement) {
        if (document.documentElement.scrollTop > 550) {
          document.getElementsByClassName("sections")[0].classList =
            "sections d-flex align-center floating";
        } else {
          document.getElementsByClassName("sections")[0].classList =
            "sections d-flex align-center";
        }
      }
    },
    customizePlan() {
      for (let value of this.data.plan)
        if (this.request.price != value.price) {
          delete this.request.plan;
          this.selectedPlan = null;
        }
    },
    showMore() {
      this.showmore = true;
    },
  },
};
